import { useState } from 'react';

const footerNav = [
  { label: '首页', href: '#top' },
  { label: '人气排行', href: '#ranking' },
  { label: '作品分类', href: '#categories' },
  { label: '同好推荐', href: '#recommend' },
  { label: '读者口碑', href: '#reputation' },
  { label: '常见问题', href: '#faq' },
];

export default function Footer() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('contact_alt') as string) || '';
    if (honeypot.trim()) {
      setFormStatus('success');
      form.reset();
      return;
    }
    formData.delete('contact_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/da1bprdrlbpoffc5h3l0', {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const msg =
        (parsed?.meta as Record<string, unknown>)?.message ||
        (parsed?.message as string) ||
        (parsed?.meta as Record<string, unknown>)?.detail ||
        responseText;
      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(typeof msg === 'string' ? msg : '订阅失败，请稍后再试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络异常，请稍后再试');
    }
  };

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">御宅书屋</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              御宅书屋是专注二次元与轻小说的人气排行与读者口碑社区。聚合读者评分、热议作品与同好推荐，
              帮助你快速找到值得一读的每一部作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#top" aria-label="微博" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#top" aria-label="哔哩哔哩" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#top" aria-label="知乎" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50">
                <i className="ri-zhihu-line text-lg"></i>
              </a>
              <a href="mailto:hello@yuzhaishuwu.example" aria-label="邮箱" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">网站导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {footerNav.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-foreground-600 transition hover:text-primary-700 whitespace-nowrap">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">订阅书单推荐</h3>
            <p className="mt-4 text-sm text-foreground-600">每周为你精选人气作品与口碑好书，不错过任何值得一读的宝藏。</p>
            <form onSubmit={handleSubmit} data-readdy-form className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center">
              <input
                type="text"
                name="contact_alt"
                autoComplete="off"
                tabIndex={-1}
                aria-hidden="true"
                readOnly
                className="contact_alt_field"
              />
              <input
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱"
                className="h-11 flex-1 rounded-lg bg-background-50 px-4 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:ring-2 focus:ring-primary-400"
              />
              <button
                type="submit"
                className="flex h-11 items-center justify-center gap-1.5 rounded-lg bg-primary-500 px-5 text-sm font-semibold text-background-50 transition hover:bg-primary-600 whitespace-nowrap"
              >
                订阅 <i className="ri-send-plane-line"></i>
              </button>
            </form>
            {formStatus === 'success' && (
              <p className="mt-3 flex items-center gap-1.5 text-xs text-accent-700">
                <i className="ri-checkbox-circle-line"></i>
                订阅成功，感谢你的关注！
              </p>
            )}
            {formStatus === 'error' && (
              <p className="mt-3 flex items-center gap-1.5 text-xs text-primary-700">
                <i className="ri-error-warning-line"></i>
                {formError}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-100">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 sm:flex-row md:px-6">
          <p className="text-xs text-foreground-500">© 2026 御宅书屋 · 同好的书架也是你的书单</p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-600 transition hover:text-primary-700 whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}